import { render, staticRenderFns } from "./dataStatistics.vue?vue&type=template&id=faafff9a&scoped=true&"
import script from "./dataStatistics.vue?vue&type=script&lang=js&"
export * from "./dataStatistics.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistics.vue?vue&type=style&index=0&id=faafff9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faafff9a",
  null
  
)

export default component.exports